import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    packages: null,
    coinPackages: null,
    userListingPackage: null
};
const getters = {
};

const actions = {
    [actionType.GET_COIN_PACKAGES]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/coin-packages', {
                params: {
                    take: params.take,
                    page: params.page,
                },
            }).then(result => {
                commit(mutationType.LIST_COIN_PACKAGES, {
                    data: result.data.data,
                    type: params.type
                })
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_PACKAGES]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/packages', {
                params: {
                    take: params.take,
                    page: params.page,
                },
            }).then(result => {
                commit(mutationType.LIST_PACKAGES, {
                    data: result.data.data,
                })
                resolve(true)
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_AGENCY_PACKAGES]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.get('/agency-packages', {
                params: {
                    take: params.take,
                    page: params.page,
                },
            }).then(result => {
                resolve(result.data.data)
            })
                .catch(error => reject(error));
        });
    },
    [actionType.GET_USER_LISTING_PACKAGE]: async function ({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.get(`/user/listings/${id}/package`).then(result => {
                commit(mutationType.SET_USER_LISTING_PACKAGE, {
                    data: result.data.data,
                })
                resolve(result)
            })
                .catch(error => reject(error));
        });
    },
    [actionType.PAYMENT_NEW_PACKAGE]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.post(`/user/listings/${params.id}/payment`, {
                package_detail_ids: params.package_detail_ids,
                website: params.website,
                affiliate_dates_ids:params.affiliate_dates_ids
            }).then(result => {
                resolve(result)
            })
                .catch(error => reject(error));
        });
    },
};

const mutations = {
    [mutationType.LIST_PACKAGES]: function (state, data) {
        state.packages = data.data;
    },
    [mutationType.LIST_COIN_PACKAGES]: function (state, data) {
        state.coinPackages = data.data;
    },
    [mutationType.SET_USER_LISTING_PACKAGE]: function (state, data) {
        state.userListingPackage = data.data;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}